import { render, staticRenderFns } from "./DiceStatisticsTable.vue?vue&type=template&id=23345c7a&scoped=true&"
import script from "./DiceStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./DiceStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./DiceStatisticsTable.vue?vue&type=style&index=0&id=23345c7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23345c7a",
  null
  
)

export default component.exports